export default __webpack_public_path__ + "static/media/foto-tela-restaurante-novo-delivery-1600x900.6166e6c3.png";